import { render, staticRenderFns } from "./HealthView.vue?vue&type=template&id=423b0d4a&scoped=true"
import script from "./HealthView.vue?vue&type=script&lang=js"
export * from "./HealthView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423b0d4a",
  null
  
)

export default component.exports